import { useContext } from "react";
import { FileTypes, KindOfOrder } from "../../../../types/enums";
import { FileAttachmentsButton } from "../../../common";
import { RefetchScope, WorkOrderContext } from "../context/WorkOrderContext";

export default function WorkOrderFilesButton(props: { defaultFileType?: FileTypes }) {

	const { order, refetchOrder } = useContext(WorkOrderContext);

	return (
		<FileAttachmentsButton
			attachedFiles={order.details.files}
			orderID={order.details.workOrderID}
			parentGuid={order.details.guid}
			kindOfOrder={KindOfOrder.WorkOrder}
			defaultFileType={props.defaultFileType}
			useFileTypes={true}
			onFileAdded={() => refetchOrder(RefetchScope.Files)}
			onFileDeleted={() => refetchOrder(RefetchScope.Files)}
			hideDeleteButton={true}
		/>
	)
}
